import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { Tag } from '@vio/atlas/Tag';
import { Text } from '@vio/atlas/Text';
import { Toggle } from '@vio/atlas/Toggle';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { DesktopIcon } from '../PriceWatchInfoIcon/DesktopIcon';
import { MobileIcon } from '../PriceWatchInfoIcon/MobileIcon';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1vq3d0k",
  propsAsIs: false
});
export const ContextWrapper = /*#__PURE__*/styled('div')({
  name: "ContextWrapper",
  class: "caghaxh",
  propsAsIs: false
});
export const ToggleWrapper = /*#__PURE__*/styled('div')({
  name: "ToggleWrapper",
  class: "tweo7hg",
  propsAsIs: false
});
export const SubTextWrapper = /*#__PURE__*/styled('div')({
  name: "SubTextWrapper",
  class: "s1c75o5m",
  propsAsIs: false
});
export const MainTextWrapper = /*#__PURE__*/styled('div')({
  name: "MainTextWrapper",
  class: "mjt4d7",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => Tag;
export const CustomTag = /*#__PURE__*/styled(_exp7())({
  name: "CustomTag",
  class: "c1ob3602",
  propsAsIs: true
});
type PriceWatchDetailedToggleProps = {
  isToggleOn: boolean;
  handleClick: (event: React.SyntheticEvent<Element, Event>) => void;
};
export const PriceWatchDetailedToggle = ({
  isToggleOn,
  handleClick
}: PriceWatchDetailedToggleProps) => {
  const {
    isMobile
  } = useDeviceLayout();
  return <>
      <Wrapper>
        <ContextWrapper>
          <MainTextWrapper>
            <Text variant="labelS">
              <FormattedMessageWrapper id="priceWatchDetailedToggle.title" defaultMessage="Setup a price alert" />
            </Text>
            <CustomTag variant="info" size="sm">
              <FormattedMessageWrapper id="priceWatchDesktopBanner.tag" defaultMessage="New" />
            </CustomTag>
          </MainTextWrapper>

          <SubTextWrapper>
            <Text variant="bodyXS" colorPath="content.neutral.c600">
              <FormattedMessageWrapper id="priceWatchDetailedToggle.alertMessage" defaultMessage="Alert me when the price changes" />
            </Text>

            {isMobile ? <MobileIcon /> : <DesktopIcon />}
          </SubTextWrapper>
        </ContextWrapper>

        <ToggleWrapper>
          <Toggle checked={isToggleOn} id="PriceWatchDetailedToggle" onChange={handleClick} />
        </ToggleWrapper>
      </Wrapper>
    </>;
};

require("./PriceWatchDetailedToggle.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceWatchDetailedToggle.tsx");